<template>
  <div
    class="single-step"
    :class="{
      'single-step--active': isActive,
      'single-step--done': isDone,
    }"
  >
    <div class="single-step__wrapper">
      <div class="single-step__step-number">
        <span v-if="!isDone">{{ stepNumber }}</span>
        <i v-else class="el-icon-check" />
      </div>
      <p class="single-step__title">{{ title }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
    isDone: {
      type: Boolean,
      required: true,
    },
    stepNumber: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
$component-name: 'single-step';

.#{$component-name} {
  display: inline-block;
  text-align: center;
  width: 0;
  height: 0;
  padding-bottom: $global-margin * 4;
  color: $lb-medium-gray;

  &__wrapper {
    width: 200px;
    transform: translateX(-50%);

    @include rtl() {
      transform: translateX(50%);
    }
  }

  &__step-number {
    border: 2px solid $lb-medium-gray;
    box-shadow: 0 0 0 7px #fff;
    width: 30px;
    height: 30px;
    display: grid;
    margin: auto;
    place-items: center;
    border-radius: 50%;
    font-weight: bold;
    background: #fff;
  }

  &__title {
    margin-top: $global-margin * 0.3;
    font-size: 0.8rem;
  }

  &--active {
    color: #000;

    .#{$component-name}__step-number {
      border-color: #000;
    }

    .#{$component-name}__title {
      font-weight: bold;
    }
  }

  &--done {
    color: $nephritis;

    .#{$component-name}__step-number {
      border-color: $nephritis;
    }
  }
}
</style>
